import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

export default function DateInput (props) {
    return (
        // <input type={props.type} value={props.value} onChange={(e) => props.setValue(props.name, e.target.value)} className={`${props.error?'error':''}`}/>
        <DatePicker dateFormat="dd/MM/yyyy" selected={new Date(props.value)} onChange={(date) => props.setValue(props.name, date)} />
    )
}